import api from '../../../core/api/client';

const BASE = '/trending-items';
const path = (id) => `${BASE}/${encodeURIComponent(id)}`;

const toApiError = (error) => {
  if (error?.response) {
    const d = error.response.data;
    return {
      status: error.response.status,
      message: d?.detail || d?.message || d?.error || error.message || 'Request failed',
      data: d,
    };
  }
  return { status: 0, message: error?.message || 'Unexpected error', data: null };
};

const wrap = async (fn) => {
  try {
    return await fn();
  } catch (error) {
    throw toApiError(error);
  }
};

export const trendingService = {
  async list({ limit = 100, region } = {}) {
    return wrap(async () => {
      const params = { limit };
      if (region) params.region = region;
      const response = await api.get(BASE, { params });
      return response.data;
    });
  },

  async capture(data) {
    return wrap(async () => {
      const response = await api.post(BASE, data);
      return response.data;
    });
  },

  async get(itemId) {
    return wrap(async () => {
      const response = await api.get(path(itemId));
      return response.data;
    });
  },

  async update(itemId, updates) {
    return wrap(async () => {
      const response = await api.patch(path(itemId), updates);
      return response.data;
    });
  },

  async delete(itemId) {
    return wrap(async () => {
      const response = await api.delete(path(itemId));
      return response.data;
    });
  },

  async archive(itemId) {
    return this.update(itemId, { archived: true });
  },

  async recordUsedIn(itemId, contentItemId) {
    return wrap(async () => {
      const response = await api.post(`${path(itemId)}/used-in`, { content_item_id: contentItemId });
      return response.data;
    });
  },
};
